import { axiosInstance } from 'services';
import { AxiosResponse } from 'axios';
import { IDaoTokensQueryParams, IDaoTokenItem, IDaoTokenResponse } from 'types/interfaces/daoTokens.interfaces';
import { daoTokensMock } from 'mockedData/daoTokens.page';

export const DaoTokensApi = {
    getDaoTokens: (queryParams: IDaoTokensQueryParams): Promise<AxiosResponse<IDaoTokenResponse>> => 
        //axiosInstance.get<IDaoTokenItem>(`dashboard/dao-tokens`, { params: queryParams }),
        Promise.resolve({
          data: daoTokensMock,
          status: 200,
          statusText: "OK",
          headers: {},
          config: {},
          request: {},
      })
};
